import React from 'react';

import { formatLatex, renderLatexInRawHtml } from 'utilities/latex';

interface Props {
  text: string;
}

const TextPreview: React.FC<Props> = (props) => {
  const textWithFormattedLatex = formatLatex(props.text);

  return (
    <div dangerouslySetInnerHTML={{ __html: renderLatexInRawHtml(textWithFormattedLatex) }} />
  );
};

export default TextPreview;
